define('modules/editor/models/property_groups/base',['require','exports','module','backbone','underscore'],function(require, exports, module) {
  var Backbone = require("backbone"),
      _ = require("underscore");

  var Serialization = {
    toJSON: function() {
      return _.extend(
        module.exports.__super__.toJSON.call(this),
        {name: this.name}
      );
    }
  };

  module.exports = Backbone.Model.extend({
    constructor: function(options) {
      //attach parent model as reference
      //instead of attribute
      if(options.parentModel){
        this.parent = options.parentModel;
        delete options.parentModel;
      }
      var properties = _.pick.apply(_, [options].concat(this.properties));
      this.validators = this.validators || {};
      module.exports.__super__.constructor.call(this, options);
    },
    applyStyles: _.identity,
    generateStyles: function() { return {}; },
    validate: function(attrs){
      var isValid = _.foldl(this.properties, function(acc, propertyName){
        //var propIsValid = (!this.validators[propertyName] || this.validators[propertyName](attrs));
        var propIsValid = true;
        if(_.isFunction(this.validators[propertyName])){
          propIsValid = this.validators[propertyName].call(this, attrs);
        }
        if(!propIsValid){
          this.trigger("invalid:property", propertyName);
        }
        return acc && propIsValid;
      }, true, this);
      return !isValid || undefined;
    },
    toJSON: Serialization.toJSON,

    //common validation functions
    isNumber: function(value){
      if(!_.isNumber(value) || _.isNaN(value)){
        return false;
      }
      return true;
    },
    isInteger: function(value){
      return /^\d+$/.test(value);
    },
    isInRange: function(value, bottomLimit, topLimit){
      if(value <= topLimit && value >= bottomLimit){
        return true;
      }
      return false;
    },
    isValidUrl: function(value){
      //allow mailto and absolute URIs (http(s), ftp)
      var urlRegEx = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
      return urlRegEx.test(value);
    },
    isValidAnchorName: function (value) {
      var anchorRegEx = /^#(.*)$/;

      return anchorRegEx.test(value);
    }
  });

});

